import React from 'react'

import { Text } from '../text/Text'

export const SectionMessageTitle = (
  props: React.ComponentProps<typeof Text>
): React.JSX.Element => <Text size="md" weight="bold" {...props} />
